import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo, LogoMark } from "@/components/Logo";
import { ThemeToggle, LanguageToggle } from "@/components/Toggles";
import { CustomerSignup } from "@/components/CustomerSignup";
import { useLang } from "@/contexts/LanguageContext";
import { Briefcase } from "lucide-react";

export default function CustomerRegister() {
  const { lang } = useLang();
  const navigate = useNavigate();
  const isAr = lang === "ar";

  return (
    <div className="min-h-screen flex flex-col lg:flex-row" data-testid="customer-register-page">
      <div className="lg:flex-1 so-gradient-hero so-grain text-white p-8 md:p-16 flex flex-col justify-between">
        <Link to="/"><Logo size={36} /></Link>
        <div className="my-12 lg:my-0">
          <LogoMark size={72} animated />
          <h2 className="mt-6 text-3xl md:text-5xl font-bold leading-tight">{isAr ? "انضم لسيرف أون." : "Join ServeOn."}</h2>
          <p className="mt-3 text-white/70 max-w-md">
            {isAr
              ? "اطلب الطعام، الأدوية، البقالة، الخدمات المنزلية والمزيد — بالاسم ورقم الهاتف فقط."
              : "Order food, medicine, groceries, home services and more — with just your name and phone."}
          </p>
        </div>
        <div className="text-xs text-white/60">© 2026 ServeOn</div>
      </div>

      <div className="lg:flex-1 flex flex-col">
        <div className="flex justify-end gap-2 p-4"><LanguageToggle /><ThemeToggle /></div>
        <div className="flex-1 flex items-center justify-center px-6 pb-10">
          <div className="w-full max-w-md">
            <CustomerSignup onSuccess={() => navigate("/app", { replace: true })} />

            <div className="mt-6 pt-5 border-t border-[var(--so-border)] text-center">
              <Link to="/business" data-testid="register-business-link"
                className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--so-text-soft)] hover:text-[var(--so-orange)]">
                <Briefcase className="w-4 h-4" />
                {isAr ? "هل أنت صاحب عمل؟ سجّل نشاطك" : "Are you a business owner? Register your business"}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
